import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { fetchOwnerEffectivePermissionsHistory } from 'api/owners/owners';
import { useQuery } from 'hooks/useQuery/useQuery';
import { QueryKeyEnum } from 'core/global.enum';
import {
  OwnerEffectivePermissionsHistoryQueryKeysEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useOwnerHistoryQuery } from '../hooks/useOwnerHistoryQuery';
import { fetchServers } from 'api/servers/servers';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';

import { OwnerEffectivePermissionsHistory } from './OwnerEffectivePermissionsHistory';

export const OwnerEffectivePermissionsHistoryContainer = () => {
  const { id } = useParams<{ id: string }>();

  const { query: ownerHistoryQuery, clearOwnerHistoryQuery } = useOwnerHistoryQuery(
    QueryKeyLocalStorageEnum.OWNER_EFFECTIVE_PERMISSIONS_HISTORY,
  );
  const [tkdSearchQuery, setTkdSearchQuery] = useState(ownerHistoryQuery?.tkd?.label || '');
  const [executorSearchQuery, setExecutorSearchQuery] = useState(ownerHistoryQuery?.wykonawca?.label || '');

  const { page, rowsPerPage, setPage, setRowsPerPage, storedQueryWithoutPagination, setPaginationCount } =
    useSavedPagination({
      queryKey: QueryKeyLocalStorageEnum.OWNER_EFFECTIVE_PERMISSIONS_HISTORY,
      resetPaginationDependencyArray: [tkdSearchQuery, executorSearchQuery],
    });

  const { data: serversResponse } = useQuery([QueryKeyEnum.SERVERS], fetchServers);

  const { data: ownerHistoryResponse, isLoading } = useQuery(
    [
      QueryKeyEnum.OWNER_HISTORY,
      id,
      storedQueryWithoutPagination,
      rowsPerPage,
      page,
      tkdSearchQuery,
      executorSearchQuery,
    ],
    () => fetchOwnerEffectivePermissionsHistory(id),
    {
      args: {
        ...storedQueryWithoutPagination,
        [OwnerEffectivePermissionsHistoryQueryKeysEnum.SERWER]: ownerHistoryQuery.serwer?.value,
        [OwnerEffectivePermissionsHistoryQueryKeysEnum.CZYTNIK]: ownerHistoryQuery.tkd?.value,
        [OwnerEffectivePermissionsHistoryQueryKeysEnum.WYKONAWCA]: ownerHistoryQuery.wykonawca?.value,
        [OwnerEffectivePermissionsHistoryQueryKeysEnum.LIMIT]: rowsPerPage,
        [OwnerEffectivePermissionsHistoryQueryKeysEnum.OFFSET]: rowsPerPage * page,
      },
      onSuccess: (response) => {
        setPaginationCount(response.count);
      },
    },
  );

  const onClearOwnerHistoryQuery = () => {
    clearOwnerHistoryQuery();
    setTkdSearchQuery('');
    setExecutorSearchQuery('');
  };

  return (
    <OwnerEffectivePermissionsHistory
      ownerHistoryResponse={ownerHistoryResponse}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      servers={serversResponse?.data || []}
      onClearOwnerHistoryQuery={onClearOwnerHistoryQuery}
      executorSearchQuery={executorSearchQuery}
      setExecutorSearchQuery={setExecutorSearchQuery}
      tkdSearchQuery={tkdSearchQuery}
      setTkdSearchQuery={setTkdSearchQuery}
    />
  );
};
